const DATABASE = "model-vista-create";
const STORE = "documents";

async function database() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DATABASE, 1);
        request.onupgradeneeded = () => request.result.createObjectStore(STORE);
        request.onerror = () => reject(request.error);
        request.onsuccess = () => resolve(request.result);
    });
}

async function operation(mode, action) {
    const db = await database();
    try {
        return await new Promise((resolve, reject) => {
            const transaction = db.transaction(STORE, mode);
            const request = action(transaction.objectStore(STORE));
            transaction.oncomplete = () => resolve(request.result);
            transaction.onerror = () => reject(transaction.error);
            transaction.onabort = () => reject(transaction.error || new Error("Draft storage was interrupted."));
        });
    } finally { db.close(); }
}

export const readDraft = () => operation("readonly", store => store.get("draft"));
export const saveDraft = value => operation("readwrite", store => store.put(value, "draft"));
export const discardDraft = () => operation("readwrite", store => store.delete("draft"));

export async function saveViewerTransfer(bytes, filename) {
    const key = "viewer:" + crypto.randomUUID();
    await operation("readwrite", store => store.put({ bytes, filename, created: Date.now() }, key));
    return key;
}

export async function consumeViewerTransfer(key) {
    if (!/^viewer:[0-9a-f-]{36}$/i.test(key)) throw new Error("The Create preview link is invalid.");
    const value = await operation("readonly", store => store.get(key));
    if (!value || Date.now() - value.created > 24 * 60 * 60 * 1000) throw new Error("This Create preview has expired. Open the model from Create again.");
    await operation("readwrite", store => store.delete(key));
    return new File([value.bytes], value.filename, { type: "model/gltf-binary" });
}
